import React from "react";
import "./Header.css";
import imagenHeader from "./Components/ImagenHeader.png";
import Nav from "./Components/Nav";
const Header = () => {
  return (
    <div className="global-header">
      <Nav />
      <div className="content-header">
  <div className="texto-header">
    <h6 className="title-h6">Valor insuperable para tu inversión</h6>
    <h1 className="title-h1">
      Centraliza y automatiza tus chats con facilidad y eficiencia
    </h1>
    <p className="title-p">
      Haz que cada mensaje cuente con nuestro servicio de alta calidad{" "}
    </p>
  </div>
  <div className="imagen-header">
    <div className="svg-container">
      <svg
        width="350"
        height="350"
        viewBox="0 0 583 582"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="header__logo-bg"
      >
        <path
          opacity="0.2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M451.05 525.511C471.052 525.511 490.237 517.582 504.377 503.46C518.517 489.338 526.475 470.189 526.475 450.191L526.475 419.009C504.484 434.299 478.228 442.652 451.085 442.652L360.596 442.652L360.596 525.511L451.085 525.511L451.05 525.511ZM582.929 307.057C581.97 273.468 568.185 241.436 544.346 217.615C519.583 192.875 486.045 179 451.05 179L374.949 179L374.949 235.489L451.05 235.489C471.052 235.489 490.237 243.418 504.377 257.54C518.517 271.662 526.475 290.811 526.475 310.809C526.475 330.806 518.517 349.955 504.377 364.077C490.237 378.199 471.052 386.128 451.05 386.128L304 386.128L304 582L451.05 582C486.045 582 519.618 568.125 544.346 543.385C569.109 518.68 583 485.126 583 450.191L583 307.057L582.929 307.057Z"
          fill="url(#paint0_linear_202_140)"
        ></path>
        <path
          opacity="0.2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M131.95 56.6295C111.948 56.6295 92.7631 64.5776 78.6231 78.7349C64.483 92.8923 56.5248 112.088 56.5248 132.136V163.395C78.5165 148.067 104.772 139.693 131.915 139.693H222.404V56.6295H131.915H131.95ZM0.0710556 275.626C1.03031 309.298 14.8151 341.409 38.6543 365.289C63.4172 390.091 96.9554 404 131.95 404H208.051V347.37H131.95C111.948 347.37 92.7631 339.422 78.6231 325.265C64.483 311.108 56.5248 291.912 56.5248 271.864C56.5248 251.817 64.483 232.621 78.6231 218.464C92.7631 204.306 111.948 196.358 131.95 196.358H279V0H131.95C96.9554 0 63.3816 13.909 38.6543 38.711C13.8914 63.4776 0 97.1147 0 132.136V275.626H0.0710556Z"
          fill="url(#paint1_linear_202_140)"
        ></path>
        <defs>
          <linearGradient
            id="paint0_linear_202_140"
            x1="408.345"
            y1="384.393"
            x2="287.889"
            y2="266.183"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white"></stop>
            <stop offset="0.76" stop-color="white" stop-opacity="0"></stop>
            <stop offset="1" stop-color="white" stop-opacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="paint1_linear_202_140"
            x1="174.655"
            y1="198.097"
            x2="295.404"
            y2="316.301"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white"></stop>
            <stop offset="0.76" stop-color="white" stop-opacity="0"></stop>
            <stop offset="1" stop-color="white" stop-opacity="0"></stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
    <img
      src="https://chatby.io/images/section-two.png"
      alt=""
      className="ImagenHeader"
    />
  </div>
</div>
    </div>
  );
};
export default Header